@import url("https://unpkg.com/@phosphor-icons/web@2.0.3/src/bold/style.css");

:host {
  display: flex;
  position: relative;
}

.left-icon {
  transform: rotate(0deg);
}

.right-icon {
  transform: rotate(180deg);
}

.down-icon {
  transform: rotate(270deg);
}

.up-icon {
  transform: rotate(90deg);
}